import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadDataFromFirestore } from 'components/settings/loadData';
import { parseForm, validateEmail } from 'helpers/generalHelpers';

export default function LoadUserData() {
  const [ errors, setErrors ] = useState()
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  function exit(e) {
    e.preventDefault();
    navigate(-1);
  }

  async function handleSubmit(e) {
    e.preventDefault()
    console.log('submit');
    setSubmitting(true);
    const formItems = e.target;
    console.log('formItems', formItems);
    var formVals = parseForm(formItems);
    console.log('formVals', formVals);

    const fe = findFormErrors(formVals)
    console.log('form errors: ', fe);
    if (fe) {
        setSubmitting(false);
        return;
    }

    const email = formVals.email;
    var result = await loadDataFromFirestore(email);
    console.log('LoadUser', email, result);

    setSubmitting(false);
    navigate('/');
    }
  
  function findFormErrors(vals) {
    const isValidEmail = validateEmail(vals.email);
    if (!isValidEmail) {
      setErrors('Email format is invalid!');
      return true;
    }

    setErrors(null);
    return false;
  }

  return (
    <div className='float-start w-full'>

      <div className='bg-gray-100 flex flex-col pt-4 pb-2 tablet:px-8'>
        <div className='mx-auto w-full max-w-md mb-4'>
          <h2 className='mt-4 text-center text-3xl font-extrabold text-gray-900'>
            I Took It When
          </h2>
          <h2 className='mt-1 text-center text-2xl font-bold text-gray-900'>
            Enter User Id
          </h2>
        </div>
      </div>

    
      <div className='min-h-screen bg-gray-100 flex flex-col px-4 tablet:px-6'>
        <div className='mt-4 mx-auto w-full max-w-md'>
        {(errors) && (
          <div
            className='bg-red-100 rounded-lg py-2 px-10 mb-3 text-base text-red-700'
            role='alert'
          >
            {errors}
          </div>
        )}

        <div className='bg-white py-8 shadow rounded-lg px-10'>
            <form className='mb-0 space-y-6' onSubmit={handleSubmit}>
            <div>
                <label htmlFor='email' className='block text-sm font-medium text-gray-700' > Email address </label> 
                <div className='mt-1'>
                  <input 
                    className='formText'
                    id='email' 
                    name='email' 
                    type='email' 
                    autoComplete='email' 
                    /> 
                </div>
              </div>
                <div className='flex justify-between'>
                    <button type='submit' disabled={submitting} className='okBtn'>Load Data</button>
                    <button onClick={exit} type='button' className='cancelBtn'>Cancel</button>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
